import ChevronLeftIcon from "assets/icon/ChevronLeftIcon";
import ChevronRightIcon from "assets/icon/ChevronRightIcon";

export default function Pagination({ pageIndex = 0, totalPages = 1, onPageChange }) {
	const isFirstPage = pageIndex <= 0;
	const isLastPage = pageIndex >= totalPages - 1;

	const baseBtn = "px-1 py-1 bg-black text-white rounded-full disabled:opacity-40";

	const handlePrevious = () => {
		if (isFirstPage) return;
		onPageChange(pageIndex - 1);
	};

	const handleNext = () => {
		if (isLastPage) return;
		onPageChange(pageIndex + 1);
	};

	return (
		<div className="mt-5 flex items-center justify-end gap-4">
			<button
				className={baseBtn}
				onClick={handlePrevious}
				disabled={isFirstPage}
			>
				<ChevronLeftIcon />
			</button>

			<span className="text-sm font-medium">
				Page {pageIndex + 1} of {totalPages}
			</span>

			<button
				className={baseBtn}
				onClick={handleNext}
				disabled={isLastPage}
			>
				<ChevronRightIcon />
			</button>
		</div>
  );
}